export const MODULES_OUTCOME = '/outcome/module' as const
export const MODULES_OUTCOME_LIST = '/outcome/module/' as const
export const MODULES_OUTCOME_RECALCULATE = '/outcome/module/recalculate' as const
